// extracted by mini-css-extract-plugin
export default {"redStar":"Star_redStar__PUcZb","clickedStars":"Star_clickedStars__PzRoL"};